import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { noop, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class Multitenant {
  private currentDomain: string = window.location.hostname;

  constructor(public http: HttpClient, private config: ConfigService) {}

  getDomainClass() {
    return this.config.getThemeClass(this.currentDomain);
  }

  getNewspaperName() {
    return this.config.getNewspaperName(this.currentDomain);
  }

  getAllNewspapers(): Observable<any> {
    return this.http.get(this.config.getApiDomainByEnv() + '/newspapers').pipe(
      catchError((error) => throwError(error))
    );
  }

  getNewspapersObs() {
    let newspapers: Array<any>;
    this.getAllNewspapers().subscribe({
      next:(resp) => newspapers = resp,
      error:() => noop
    });

    return newspapers;
  }
}
